export function maskDocument(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 14);

  if (digits.length <= 11) {
    return digits
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }

  return digits
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
}

function isValidCPF(digits: string): boolean {
  if (/^(\d)\1{10}$/.test(digits)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(digits[i]) * (10 - i);
  let remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(digits[9])) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(digits[i]) * (11 - i);
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  return remainder === parseInt(digits[10]);
}

function isValidCNPJ(digits: string): boolean {
  if (/^(\d)\1{13}$/.test(digits)) return false;

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 12; i++) sum += parseInt(digits[i]) * weights1[i];
  let remainder = sum % 11;
  if ((remainder < 2 ? 0 : 11 - remainder) !== parseInt(digits[12])) return false;

  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  sum = 0;
  for (let i = 0; i < 13; i++) sum += parseInt(digits[i]) * weights2[i];
  remainder = sum % 11;
  return (remainder < 2 ? 0 : 11 - remainder) === parseInt(digits[13]);
}

export function validateDocument(value: string): string | null {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 0) return "Preencha com um CPF ou CNPJ";
  if (digits.length === 11 && isValidCPF(digits)) return null;
  if (digits.length === 14 && isValidCNPJ(digits)) return null;
  return "Preencha com um CPF ou CNPJ válido";
}

export function validateAsCPF(value: string): string | null {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 11 || !isValidCPF(digits)) return "Preencha com um CPF válido";
  return null;
}

export function validateAsCNPJ(value: string): string | null {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 14 || !isValidCNPJ(digits)) return "Preencha com um CNPJ válido";
  return null;
}
